import { useState, ChangeEvent, useEffect } from "react";
import loginLogo from "../constants/assests/image/karts-login-logo.png";
import InputFiled from "../shared/inputFiled";
import PasswordFiled from "../shared/passwordFiled";
import FillButton from "../shared/fillButton";
import { useSelector, useDispatch } from "react-redux";
import { loginUser, clearMessages } from "../models/authSlice";
import { RootState, AppDispatch } from "../reduxStore/store";
import { useNavigate } from "react-router-dom";
import {getShofifyToken} from "../models/shopifyLoginAPI"
import { useLocation } from 'react-router-dom';
import { useParams } from 'react-router-dom';


const LoginScreen: React.FC = () => {
  const [username, setUsername] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  // const [email, setEmail] = useState<string>("");

  const location = useLocation();
  const { id, email } = useParams();
  
  

  // const userId = useSelector((state: RootState) => state.auth.user?.id);
  // const email = useSelector((state: RootState) => state.auth.user?.email);
  const loading = useSelector((state: RootState) => state.auth.loading);
  const error = useSelector((state: RootState) => state.auth.error);
  const successMessage = useSelector(
    (state: RootState) => state.auth.successMessage
  );

  const dispatch: AppDispatch = useDispatch();
  const navigate = useNavigate();


 

  useEffect(() => {

    dispatch(clearMessages());
    if (successMessage) {
      navigate("/homePage");
    }
  }, [successMessage, navigate]);

  const handleLogin = () => {
    dispatch(loginUser({ username, password }));
  };

  useEffect(() => {
    const fetchUser = async () => {
      try {
        // const token = localStorage.getItem("accessToken");
        // console.log("App Token " + token);
        
        // if (token) {
          console.log("Go to the home page.!");
          // const params = new URLSearchParams(location.search);
          navigate(`/homePage?email=?&id=?`);
         
          // console.log("e email ",email);
          // console.log("Window",window.location.pathname);
          // console.log("href",window.location.href);
        // } else {
        //   console.log("Go to the Login page.!");
        //   navigate("/");
        // }
      } catch (error) {
        console.error("Token is null.!");
        navigate("/homePage");
      }
    };

    fetchUser();
  }, []);

  const isButtonDisabled = loading || username === "" || password === "";

  return (
    <div className="min-h-[100vh] max-h-[100vh] w-screen overflow-x-hidden">
      <div className="flex h-[30vh] justify-center items-center">
        <img src={loginLogo} width={280} height={280} alt="Login Logo" />
      </div>
      <div className="h-[50vh] flex flex-col justify-center items-center">
        <InputFiled
          placeholder="User Name"
          value={username}
          onChange={(e: ChangeEvent<HTMLInputElement>) =>
            setUsername(e.target.value)
          }
        />
        <PasswordFiled
          placeholder="Password"
          value={password}
          onChange={(e: ChangeEvent<HTMLInputElement>) =>
            setPassword(e.target.value)
          }
        />
        {successMessage && <p style={{ color: "green" }}>{successMessage}</p>}
        {error && <p style={{ color: "red" }}>{error}</p>}
      </div>
      <div className="w-[20]">
        <div className="flex justify-center items-center">
          <FillButton name="Login" onClick={handleLogin} disabled={isButtonDisabled} />
        </div>
        <div className="flex justify-center items-center"></div>
      </div>
    </div>
  );
};

export default LoginScreen;
